import cx from 'classnames';
import { ElipsisTooltip } from '../../common/ElipsisTooltip';
import ActionLink from './ActionLink';
import styles from './Wrapper.module.scss';
import DeductImagineCredit from './DeductImagineCredit';

export default function Wrapper({
  id,
  showTooltip = {},
  children,
  title,
  description,
  className = '',
  childrenClassName = '',
  childrenStyle = {},
  style = {},
  buttonTitle = '',
  productUsageViewTitle = '',
  productUsageViewbuttonClick = () => {},
  buttonClick = () => {},
  isImagineCreditModal = false
}) {
  const { icon, message } = showTooltip;
  const Icon = icon;

  return (
    <div className={`${styles.container} ${className}`} style={style} id={id}>
      {title && (
        <div className={styles.innerContainer}>
          <div className={styles.info}>
            {title && (
              <div className={cx(styles.title, 'd-flex gap-2')}>
                {title}{' '}
                {Icon && message && (
                  <ElipsisTooltip title={message} alwaysShow={true}>
                    {(props) => (
                      <div style={{ cursor: 'pointer', width: 24, height: 24 }} {...props}>
                        <Icon />
                      </div>
                    )}
                  </ElipsisTooltip>
                )}
              </div>
            )}
            {description && <div className={styles.description}>{description}</div>}
          </div>
          <span className="d-flex gap-3">
            {isImagineCreditModal && <DeductImagineCredit />}
            {productUsageViewbuttonClick && (
              <ActionLink title={productUsageViewTitle} onClick={productUsageViewbuttonClick} />
            )}
            {buttonClick && <ActionLink title={buttonTitle} onClick={buttonClick} />}
          </span>
        </div>
      )}
      {children && (
        <div className={`d-flex flex-wrap w-100 ${childrenClassName}`} style={childrenStyle}>
          {children}
        </div>
      )}
    </div>
  );
}
